export enum EMessageRole {
  USER = 'human',
  AI = 'ai',
}

export type TMessage = {
  type: EMessageRole;
  content: string;
};

export interface TArtifact {
  id: string;
  contents: TArtifactContent[];
  current_content_index: number;
}

export interface TArtifactContent {
  index: number;
  content: string;
}

export interface THighlight {
  prompt_chunk_start_index: number;
  prompt_chunk_end_index: number;
  prompt_chunk: string;
  highlight_text: string;
}

export type TArtifactLengthOptions = 'shortest' | 'short' | 'long' | 'longest';

export type TReadingLevelOptions = 'child' | 'teenager' | 'college' | 'phd';

export enum EQuickAdjustment {
  READING_LEVEL = 'Reading level',
  LENGTH = 'Length',
  CUSTOM = 'Custom',
}

type TAdjustmentComponentProps = {
  marks: { value: number; label: string }[];
  options: (TArtifactLengthOptions | TReadingLevelOptions)[];
};

export const adjustmentToComponentProps: Record<
  Exclude<EQuickAdjustment, EQuickAdjustment.CUSTOM>,
  TAdjustmentComponentProps
> = {
  [EQuickAdjustment.LENGTH]: {
    marks: [
      { value: 2, label: 'Make longer' },
      { value: 0, label: 'Keep same' },
      { value: -2, label: 'Make shorter' },
    ],
    options: ['shortest', 'short', 'long', 'longest'],
  },
  [EQuickAdjustment.READING_LEVEL]: {
    marks: [
      { value: 2, label: 'Make more complex' },
      { value: 0, label: 'Keep same' },
      { value: -2, label: 'Make simpler' },
    ],
    options: ['child', 'teenager', 'college', 'phd'],
  },
};
